import { useQuery, UseQueryResult } from '@tanstack/react-query';
import {
  getNewPrincipalMandateAssignments,
  getPrincipalMandateAssignments,
} from '../../utils/principal-service/principal-endpoints';
import { CRMMandatesPayload } from '../../utils/types/Crm.types';
import { Mandates } from '../../utils/types/Mandate.types';

export const useCRMMandates = (
  { filter, principalPri, portfolioLevel }: CRMMandatesPayload,
  allowIncompleteFilter?: boolean,
): UseQueryResult<Mandates | undefined> => {
  return useQuery({
    queryFn: () => {
      if (!principalPri) {
        return undefined;
      }
      if (portfolioLevel) {
        return getNewPrincipalMandateAssignments(principalPri, portfolioLevel);
      }
      if (filter?.hasAllMandates || !filter) {
        return getPrincipalMandateAssignments(principalPri);
      }
      if (allowIncompleteFilter) {
        return getPrincipalMandateAssignments(principalPri, filter);
      }
      if (
        filter &&
        (filter.countries?.length || filter.territories?.length) &&
        filter.marketSegments?.length &&
        filter.portfolios?.length
      ) {
        return getPrincipalMandateAssignments(principalPri, filter);
      }
      return undefined;
    },
    queryKey: [
      'mandates',
      principalPri,
      portfolioLevel,
      {
        hasAllMandates: filter?.hasAllMandates,
        countries: filter?.countries,
        marketSegments: filter?.marketSegments,
        portfolios: filter?.portfolios,
        territories: filter?.territories,
      },
    ],
    enabled: !!principalPri,
    refetchOnWindowFocus: false,
  });
};
